$(document).ready(function() {
    //getFreeShipping();

    var paramsSlick = { 
        slidesToShow: 4 ,
        dots: true,
    
        responsive: [
            {
                breakpoint: 1900,
                settings: {
                  slidesToShow: 5,
                  slidesToScroll: 1,
                  infinite: true,
                  dots: true
                }
            },
            {
                breakpoint: 1400,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1,
                  infinite: true,
                  dots: true
                }
            },
            { 
                breakpoint: 1200,
                settings: {
                  slidesToShow: 4, 
                  slidesToScroll: 1,
                  infinite: true,
                  dots: true
                }
            },
            {
                breakpoint: 991,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 2,
                  infinite: true,
                  dots: true
                }
            }
            ,{
                breakpoint: 680,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                  infinite: true,
                  dots: true
                }
            },
            {
                breakpoint: 450, 
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  infinite: true,
                  dots: true
                }
            }
        ]
    };

    $(".cartSubtotal").on("change");
    $("#featuredProducts").slick(paramsSlick);


    refreshSlider();

    $(window).resize(function(){
        refreshSlider();
    });

    function refreshSlider (){
        
        $('#featuredProducts')[0].slick.refresh();
    }

    setTimeout(function(){
        $("#featuredProducts").slick('unslick').slick(paramsSlick);
        $('#featuredProducts')[0].slick.refresh();  
    },1500); 


});
function getFreeShipping(items) {
    const freeShippingTier = 599.0;
    const maxWeigth = 10000;
    const hasData = !!$(".functionCart .cartSubtotal").html();
    if (!hasData) return;
    let subTotal = parseFloat(
        $(".functionCart .cartSubtotal").html().match(/\d*\.\d*/gi)[0]
    );
    let pesoTotal=0;
    for(let i in items){
        let pesoExtra=parseFloat(items[i].grams);
        pesoTotal+=isNaN(pesoExtra)?0:pesoExtra;
    }
    if (freeShippingTier > subTotal || pesoTotal >= maxWeigth) {
        
        $(".spendMoreToFreeShipping")
            .html(
                "Si compras " +
                    (freeShippingTier - subTotal).toFixed(2) +
                    " más, tendrás el envío gratis!"
            )
            .addClass("red")
            .removeClass("green");
    } else {
        $(".spendMoreToFreeShipping")
            .html("Tienes envío gratis")
            .addClass("green")
            .removeClass("red");
    }
};
